// extracted by mini-css-extract-plugin
module.exports = {"header":"YqA7J6","categoryPage":"krgA5p","shouldNotShowFilterTitle":"pEfMg1","title":"ptBG4I","cancel":"uIETfi"};